// ComingSoon.tsx
import React, { useEffect, useState } from 'react';
import './ComingSoon.css';

interface ComingSoonProps {
  message?: string;
  subMessage?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  message = "We are working on this", 
  
}) => {
  const [animatedText, setAnimatedText] = useState<string>('');
  const [showSubtitle, setShowSubtitle] = useState<boolean>(false);
  const [glow, setGlow] = useState<boolean>(false);

  // Typewriter effect for main message
  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex <= message.length) {
        setAnimatedText(message.substring(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(interval);
        setTimeout(() => setShowSubtitle(true), 500);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [message]);

  // Glow effect for "Coming soon"
  useEffect(() => {
    const glowInterval = setInterval(() => {
      setGlow(prev => !prev);
    }, 2000);

    return () => clearInterval(glowInterval);
  }, []);

  return (
    <div className="coming-soon-container">
      <div className="stars">
        {[...Array(30)].map((_, i) => (
          <div 
            key={i} 
            className="star" 
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
            }}
          />
        ))}
      </div>

      <div className="main-content">
        <div className="message-container">
          <h1 className="animated-text">
            {animatedText}
            <span className="cursor">|</span>
          </h1>
        </div>

       <div className={`subtitle-container ${showSubtitle ? 'visible' : ''}`}>
          <h2 className={`coming-soon-text ${glow ? 'glow' : ''}`}>
            <span className="word">
              {"Coming".split('').map((char, index) => (
                <span 
                  key={index}
                  className="letter"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {char}
                </span>
              ))}
            </span>
            <span className="space">&nbsp;</span>
            <span className="word">
              {"Soon!".split('').map((char, index) => (
                <span 
                  key={index + 10}
                  className="letter"
                  style={{ animationDelay: `${(index + 7) * 0.1}s` }}
                >
                  {char}
                </span>
              ))}
            </span>
          </h2>
        </div>

        <div className={`progress-container ${showSubtitle ? 'visible' : ''}`}>
          <div className="progress-bar">
            <div className="progress-fill" />
          </div>
          <div className="progress-text">Progress: 85%</div>
        </div>

        <div className={`decoration ${showSubtitle ? 'visible' : ''}`}>
          <div className="gear gear1">
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
          </div>
          <div className="gear gear2">
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
          </div>
          <div className="gear gear3">
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
            <div className="gear-tooth"></div>
          </div>
        </div>

        <div className={`floating-elements ${showSubtitle ? 'visible' : ''}`}>
          <div className="floating-element el1">🚀</div>
          <div className="floating-element el2">✨</div>
          <div className="floating-element el3">💡</div>
          <div className="floating-element el4">⚡</div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;